import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LoadingServiceService } from '../../services/loadingService/loading-service.service';

@Component({
  selector: 'app-loading-indicator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading-indicator.component.html',
  styleUrl: './loading-indicator.component.scss'
})
export class LoadingIndicatorComponent {
  constructor(
    public loadingService: LoadingServiceService
  ){}
}
